import { useFormContext } from "react-hook-form";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "../form/Form";
import { Textarea } from "./Textarea";
import FormRequiredLabel from "../label/FormRequiredLabel";

const FormTextarea = ({ name, label, placeholder, required = false }) => {
  const { control } = useFormContext();

  return (
    <div>
      <FormField
        control={control}
        name={name}
        render={({ field }) => (
          <FormItem>
            {required ? (
              <FormRequiredLabel text={label} />
            ) : (
              <FormLabel>{label}</FormLabel>
            )}
            <FormControl>
              <Textarea
                placeholder={placeholder}
                className="resize-none"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};

export default FormTextarea;
